// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"06595473","185":"56e8eded","189":"0d226535","615":"84929e7f","684":"71d93f14","983":"7f650731","997":"0171fe21"}[chunkId] + ".chunk.js";
};